import React, { useState, useEffect } from "react";
import { MapContainer as LeafletMap, TileLayer } from "react-leaflet";

import InfoBox from "./InfoBox";
import Table from "./Table";
import Map from "./Map";
import "./App.css";
import {
  Card,
  CardContent,
  MenuItem,
  FormControl,
  Select,
} from "@material-ui/core";
import { numWithComas, sortData, prettyPrintStat } from "./util";
import LineGraph from "./LineGraph";
import "leaflet/dist/leaflet.css";
import { map } from "leaflet";

function App() {
  // State is a short term memory in react
  // STATE = how to write a variable in React
  const [countries, setCountries] = useState([]);
  // a state to Keep track of what is selected
  const [country, setCountry] = useState("worldwide");
  const [lineCountry, setLineCountry] = useState("all");
  const [countryInfo, setCountryInfo] = useState({});
  const [tableData, setTableData] = useState([]);
  const [mapCenter, setMapCenter] = useState([34.80746, 22]);
  const [mapZoom, setMapZoom] = useState(2.2);
  const [countryName, setCountryName] = useState("Worldwide");
  const [mapCountries, setMapCountries] = useState([]);
  const [casesType, setCasesType] = useState("cases");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowLarge, setWindowLarge] = useState(false);

  //To make a call to the API, we use something called Useeffect
  // USEEFFECT = Runs a piece of code based on a given condition
  // https://disease.sh/v3/covid-19/countries

  useEffect(() => {
    fetch("https://disease.sh/v3/covid-19/all")
      .then((response) => response.json())
      .then((data) => {
        setCountryInfo(data);
      });
  }, []); // When the second element is empty, this useEffect is executed once upon loaded

  useEffect(() => {
    // When the second argument is left empty,
    //The code inside here will run
    // once when the App component (or whatever component) loads and not again after
    // When the second argument is filled with some variable, it runs once on load and
    // whenever the value changes.

    // async -> send a request to the server, wait for it, and then do something with the response

    const getCountriesData = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries")
        .then((response) => response.json())
        .then((data) => {
          const countries = data.map((country) => ({
            name: country.country,
            value: country.countryInfo.iso2,
          }));
          const sortedData = sortData(data);
          setTableData(sortedData);
          setMapCountries(data);
          setCountries(countries);
        });
    };

    getCountriesData();
  }, []);

  useEffect(() => {
    updateWindowWidth();
    window.addEventListener("resize", updateWindowWidth);
  }, [window.innerWidth]);

  let onCountryChange = async (event) => {
    const countryCode = event.target.value;
    setCountry(countryCode);
    setLineCountry(countryCode);

    const url =
      countryCode === "worldwide" // This is an if statement
        ? // URL for worldwide
          "https://disease.sh/v3/covid-19/all"
        : // URL for each country, Use backticks here
          `https://disease.sh/v3/covid-19/countries/${countryCode}`;

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        // setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
        setMapZoom(4);
        setCountryInfo(data);
        setCountryName(data.country);
      });
  };

  const updateWindowWidth = () => {
    setWindowWidth(window.innerWidth);
    windowWidth > 1025 ? setWindowLarge(true) : setWindowLarge(false);
  };

  const stampToDate = (digitDate) => {
    let dateDate = new Date(digitDate).toLocaleDateString("en-US");
    return dateDate;
  };
  // console.log("CountryInfo>>>>", countryInfo);

  return (
    <div className="app">
      <div className="app__">
        <div className="app__left">
          {/* Header */}
          <div className="app__header">
            <div>
              <h1>COVID-19 TRACKER</h1>
              <time>As of: {stampToDate(countryInfo.updated)}</time>
              <div></div>
            </div>
            <FormControl className="app__dropdown">
              <Select
                variant="outlined"
                value={country}
                onChange={onCountryChange}
                // Onchange will be triggered whenever we click the dropdown
              >
                {/* Loop throgh all the countries and show the drop down list */}
                <MenuItem value="worldwide">Worldwide</MenuItem>
                {countries.map((country) => (
                  <MenuItem value={country.value}>{country.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="app__stats">
            <InfoBox
              isRed
              active={casesType === "cases"}
              onClick={(e) => setCasesType("cases")}
              title="Cases"
              cases={numWithComas(countryInfo.todayCases)}
              total={prettyPrintStat(countryInfo.cases)}
            />
            <InfoBox
              active={casesType === "recovered"}
              onClick={(e) => setCasesType("recovered")}
              title="Recoverd"
              cases={numWithComas(countryInfo.todayRecovered)}
              total={prettyPrintStat(countryInfo.recovered)}
            />
            <InfoBox
              isRed
              active={casesType === "deaths"}
              onClick={(e) => setCasesType("deaths")}
              title="Deaths"
              cases={numWithComas(countryInfo.todayDeaths)}
              total={prettyPrintStat(countryInfo.deaths)}
            />
          </div>
          {/* Title + Select inpurt dropdown field */}

          {/* Map */}
          <Map
            casesType={casesType}
            countries={mapCountries}
            center={mapCenter}
            zoom={mapZoom}
          />
          {/* <div className="map">
          <LeafletMap center={mapCenter} zoom={mapZoom}>
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
          </LeafletMap>
        </div> */}
        </div>
        <div className="app__right">
          <div className="app__rightinside">
            <Card className="app__linecard">
              <CardContent>
                <div className="app__line">
                  <h3>
                    {countryName} new {casesType}
                  </h3>
                  <LineGraph
                    className="app__graph"
                    country={lineCountry}
                    casesType={casesType}
                    windowLarge={windowLarge}
                  />
                  {/* Graph */}
                </div>
              </CardContent>
            </Card>
            <Card className="app__tablecard">
              <CardContent>
                <div className="app__righttable">
                  <h3>Live Cases by Coutnry</h3>
                  <Table countries={tableData} />
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
      <div class="app__fotter">
        <div>
          Made by <a href="https://github.com/YoheiKo">YoheiKo</a>
        </div>
      </div>
    </div>
  );
}

export default App;
